import { File } from "../classes/File.js";
export const serverMemberHydration = {
    keyMapping: {
        _id: "id",
        joined_at: "joinedAt",
    },
    functions: {
        id: (member) => member._id,
        joinedAt: (member) => new Date(member.joined_at),
        nickname: (member) => member.nickname,
        avatar: (member, ctx) => new File(ctx, member.avatar),
        roles: (member) => member.roles,
        timeout: (member) => new Date(member.timeout),
    },
    initialHydration: () => ({
        roles: [],
    }),
};
